"use strict";

var _classCallCheck = require("/home/runner/work/bachelor-user-frontend/bachelor-user-frontend/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/runner/work/bachelor-user-frontend/bachelor-user-frontend/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/home/runner/work/bachelor-user-frontend/bachelor-user-frontend/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/home/runner/work/bachelor-user-frontend/bachelor-user-frontend/node_modules/react-scripts/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/runner/work/bachelor-user-frontend/bachelor-user-frontend/node_modules/react-scripts/node_modules/@babel/runtime/helpers/getPrototypeOf");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebSocketChannel = void 0;
var events_1 = require("events");
var logger_1 = require("./logger");
var WebSocketChannel = /*#__PURE__*/function (_events_1$EventEmitte) {
  _inherits(WebSocketChannel, _events_1$EventEmitte);
  var _super = _createSuper(WebSocketChannel);
  function WebSocketChannel(url) {
    var _this;
    _classCallCheck(this, WebSocketChannel);
    _this = _super.call(this);
    _this.url = url;
    _this.WebSocket = global['WebSocket'] || global['MozWebSocket'] || require('ws');
    return _this;
  }
  _createClass(WebSocketChannel, [{
    key: "isConnected",
    get: function get() {
      return this.socket && this.socket.readyState === 1;
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this2 = this;
      logger_1.log.trace('connecting to socket');
      var socket = new this.WebSocket(this.url);
      socket.binaryType = 'arraybuffer';
      socket.onopen = function () {
        logger_1.log.debug("socket opened ".concat(_this2.url));
        _this2.emit('connected');
      };
      socket.onclose = function (e) {
        logger_1.log.debug('socket closed', e);
        _this2.emit('disconnected', e);
      };
      socket.onerror = function (e) {
        logger_1.log.debug('error:', e);
        _this2.emit('socketError', e);
      };
      socket.onmessage = function (message) {
        _this2.emit('message', message.data);
      };
      this.socket = socket;
    }
  }, {
    key: "send",
    value: function send(message) {
      this.socket.send(message);
    }
  }, {
    key: "close",
    value: function close() {
      logger_1.log.trace('closing socket');
      if (this.socket) {
        this.socket.onopen = null;
        this.socket.onclose = null;
        this.socket.onerror = null;
        this.socket.onmessage = null;
        try {
          this.socket.close();
        } finally {}
      }
    }
  }]);
  return WebSocketChannel;
}(events_1.EventEmitter);
exports.WebSocketChannel = WebSocketChannel;